var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"points":"20 6 9 17 4 12"}));
}

Check.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-check"};

module.exports = Check;

Check.default = Check;
